import { render, staticRenderFns } from "./ui-checkbutton.vue?vue&type=template&id=54679627&"
import script from "./ui-checkbutton.vue?vue&type=script&lang=js&"
export * from "./ui-checkbutton.vue?vue&type=script&lang=js&"
import style0 from "./ui-checkbutton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54679627')) {
      api.createRecord('54679627', component.options)
    } else {
      api.reload('54679627', component.options)
    }
    module.hot.accept("./ui-checkbutton.vue?vue&type=template&id=54679627&", function () {
      api.rerender('54679627', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/kit/ui-checkbutton/ui-checkbutton.vue"
export default component.exports